import React, { Component } from 'react';
import { Redirect, Route } from 'react-router-dom';

import {
    IonApp,
    IonRouterOutlet,
    IonTabs,
    IonTabBar,
    IonTabButton,
    IonIcon,
    IonLabel,
} from '@ionic/react';

import { IonReactRouter } from '@ionic/react-router';

import { ScreenOrientation } from '@ionic-native/screen-orientation';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */

import './theme/app.css';
// import './theme/variables.css';

/** =========================================
 *  -- COMPONENTS
    ========================================= */
import {
    personCircleOutline, informationCircleOutline, homeOutline
} from 'ionicons/icons';

import { AdminOnly, RequiresLogin, RequiresLogout } from '@acri-tools/react-tools/utils/routing';
import DeletedAnomaliesSearch from './pages/DeletedAnomaliesSearch/Search';

// import Toasts from './components/Toasts/Toasts';

/** =========================================
 *  -- PAGES
    ========================================= */
import LoadingPage from './pages/LoadingPage/LoadingPage';

// generic pages
import Home from './pages/Home/Home';
import Anomalies from './pages/Anomalies/Anomalies';

/** =========================================
 *  -- METHODS
    ========================================= */
// import { MOBILE_MODE } from './utils/config';
import Async from 'react-async';

// mobile
import { isMobile } from 'react-device-detect';
// import {
//     Plugins,
//     StatusBarStyle
// } from '@capacitor/core';

import { Capacitor, Plugins } from '@capacitor/core';

// Redux
import { connect } from 'react-redux';

import routes from './utils/routes';
import Menu from '@acri-tools/react-tools/components/Menu/Menu';
import { createBrowserHistory } from 'history';
import { on_app_mount, on_app_unmount, set_languages } from '@acri-tools/react-tools';
import { setArticleManager, setCatalog, setLogin, setRouting } from '@acri-tools/react-tools/redux/actions';
import Toasts from '@acri-tools/react-tools/components/Toasts/Toasts';
import Login from './pages/Login/Login';
import { initLogin } from '@acri-tools/react-tools/utils/login';
import Admin from '@acri-tools/react-tools/pages/Admin/Admin';
import { GDPRBanner, GDPRProvider } from '@acri-tools/gdpr-library';
import { GDPR_PATH } from './gdpr/setup';
import Register from './pages/Register/Register';
import VerifyRegistration from './pages/VerifyRegistration/VerifyRegistration';
import Account from './pages/Account/Account';
import Gdpr from './pages/Gdpr/Gdpr';
import PrivacySettingsPage from './pages/PrivacySettings/PrivacySettingsPage';

import languages from './languages';

// testing rebuild

interface Props {
    // ======== REDUX =========
    // notifications?: any,
    // setArticleManager?:any
    // setCatalog?:any
    // setRouting?:any
    setLogin?: any

    languages?: any
}
const history = createBrowserHistory();

class App extends Component<Props, {}> {
    defaultLoggedinRedirect = () => {
        return (
            isMobile ?
                <Redirect to="/" />
                :
                <Redirect to="/" />
        )
    }
    componentDidMount() {
        // Capacitor 2 has no web Keyboard plugin: each addListener call in on_app_mount
        // returns its own rejected promise, so stub the plugin in the browser.
        if (!Capacitor.isNative && !Capacitor.isPluginAvailable('Keyboard')) {
            (Plugins as any).Keyboard = { addListener: () => ({ remove: () => {} }) };
        }
        on_app_mount(history);

        set_languages(languages, 'en');

    }
    componentWillUnmount() {
        on_app_unmount();
    }

    render() {
        return (
            <IonApp id="app" className={isMobile ? 'mobile' : undefined}>

                {/* <Async promiseFn={async()=>{ }}> */}
                <Async promiseFn={async () => { await initLogin() }}>
                    {
                        ({ data, error, isLoading }) => {
                            if (isLoading) {
                                return (<LoadingPage />);
                            }

                            else {
                                return (
                                    <GDPRProvider>
                                    <IonReactRouter history={history}>
                                        <Menu routes={routes} />
                                        <Toasts />
                                        <GDPRBanner
                                            privacyPoliciesPath={GDPR_PATH}
                                            message={
                                                <p>
                                                    We use cookies for the site to work, to keep you signed in, and, if you agree, for anonymous usage statistics. See our{' '}
                                                    <a className="gdpr-link" href={GDPR_PATH}>GDPR notice</a>.
                                                </p>
                                            }
                                        />
                                        <IonTabs>
                                            <IonRouterOutlet animated={false} id="mobile-menu">
                                                <Route path="/admin/:selected?/:subSelected?" exact render={(props) =>
                                                    <RequiresLogin>
                                                        <AdminOnly>
                                                            <Admin
                                                                routes={routes}
                                                                // logo={logo}
                                                                // custom_menu={admin_routes}
                                                                // file_manager
                                                                // article_manager
                                                                {...props}

                                                                custom_menu={{
                                                                    "deleted": {
                                                                        icon: "fas fa-exclamation-triangle",
                                                                        subMenu: {
                                                                            "search": {
                                                                                icon: "fas fa-filter",
                                                                                component: <DeletedAnomaliesSearch />
                                                                            },

                                                                        }
                                                                    },
                                                                }}
                                                            />
                                                        </AdminOnly>
                                                    </RequiresLogin>
                                                } />

                                                <Route path="/" exact render={() =>
                                                    <Home />
                                                } />
                                                <Route path="/gdpr" exact render={() =>
                                                    <Gdpr />
                                                } />
                                                <Route path="/privacy-settings" exact render={() =>
                                                    <PrivacySettingsPage />
                                                } />
                                                <Route path="/anomalies" exact render={() =>
                                                    <Anomalies />
                                                } />
                                                <Route path="/login" exact render={() =>
                                                    <RequiresLogout>
                                                        <Login />
                                                    </RequiresLogout>
                                                } />
                                                <Route path="/account" exact render={(props) =>
                                                    <RequiresLogin>
                                                        <Account />
                                                    </RequiresLogin>
                                                } />
                                                <Route path="/register" exact render={(props) =>
                                                    <RequiresLogout>
                                                        <Register />
                                                    </RequiresLogout>
                                                } />
                                                <Route path="/verify-registration/:token" exact render={(props) =>
                                                    <RequiresLogout>
                                                        <VerifyRegistration {...props} />
                                                    </RequiresLogout>
                                                } />
                                                {/* <Route path="/forgot-password" exact render={(props) => 
                                                    <RequiresLogout>
                                                        <ForgotPassword {...props} />
                                                    </RequiresLogout>
                                                }/> */}
                                                {/* <Route path="/update-password/:token" exact render={(props) => 
                                                    <UpdatePassword {...props} />
                                                }/>
                                                <Route path="/update-email/:token" exact render={(props) => 
                                                    <UpdateEmail {...props} />
                                                }/> */}

                                            </IonRouterOutlet>


                                            {/* TAB BAR IS CURRENTLY DISABLED */}
                                            <IonTabBar
                                                slot="bottom" id="tab-bar"
                                                style={isMobile && false ? undefined : { display: "none" }}
                                            >
                                                <IonTabButton tab="home" href="/">
                                                    <IonIcon icon={homeOutline} />
                                                    <IonLabel>Home</IonLabel>
                                                </IonTabButton>

                                                <IonTabButton tab="contact" href="/contact">
                                                    <IonIcon icon={informationCircleOutline} />
                                                    <IonLabel>Contact</IonLabel>
                                                </IonTabButton>
                                            </IonTabBar>
                                        </IonTabs>
                                    </IonReactRouter>
                                    </GDPRProvider>
                                )
                            }
                        }
                    }
                </Async>
            </IonApp>
        )
    }
};

const mapStateToProps = (state: any) => {
    return {
        login: state.login,
        notifications: state.notifications,
    }
}

// export default App;
export default connect(mapStateToProps, { setArticleManager, setCatalog, setRouting, setLogin })(App);
